/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Detail_Score_Signal_StrongInputs */

const en_directory_detail_score_signal_strong = /** @type {(inputs: Directory_Detail_Score_Signal_StrongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Strong signal`)
};

const zh_directory_detail_score_signal_strong = /** @type {(inputs: Directory_Detail_Score_Signal_StrongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`强信号`)
};

/**
* | output |
* | --- |
* | "Strong signal" |
*
* @param {Directory_Detail_Score_Signal_StrongInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_detail_score_signal_strong = /** @type {((inputs?: Directory_Detail_Score_Signal_StrongInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Detail_Score_Signal_StrongInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_detail_score_signal_strong(inputs)
	return zh_directory_detail_score_signal_strong(inputs)
});
export { directory_detail_score_signal_strong as "directory.detail.score_signal.strong" }